import React from 'react';

import { Form, FormField, Textarea } from '@amzn/awsui-components-react-v3';

interface useCaseProps {
  value: string;
  formSubmitted?: boolean;
  onChange?: (event: string | undefined) => void;
}

const UseCaseComponent = (props: useCaseProps) => {
  const handleUseCaseChange = (event: CustomEvent | undefined) => {
    if (!!props.onChange) props.onChange(event.detail.value);
  };

  return (
    <Form>
      <FormField
        label={'Use case (required)'}
        description={
          'Provide a detailed business justification for the data access including requirements, business outcome and if the data is copied or stored locally, etc.'
        }
        errorText={props.formSubmitted && !props.value && 'Use case is required.'}
      >
        <Textarea value={props.value} onChange={handleUseCaseChange} placeholder='Enter use case' />
      </FormField>
    </Form>
  );
};

export default UseCaseComponent;
